<template>
  <ul>
    <li
        v-for="item in items"
        :key="item.text">
      <settings-menu-item
          :item="item"/>
      <settings-menu-list
          v-if="item.items"
          :items="item.items"/>
    </li>
  </ul>
</template>

<script>
import SettingsMenuItem from './SettingsMenuItem.vue';

export default {
  name: 'SettingsMenuList',
  components: {
    SettingsMenuItem,
  },
  props: {
    items: Array,
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;

  ul li a {
    padding-left: 3rem;
  }
}
</style>
